module.exports = __webpack_public_path__ + "static/about-3@2x-7211c6a86f767c40757a1e3cd154c544.jpg";